// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BfgC9Rf78SzqkGXkVG9P {
    justify-content: center;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 5px;
    width: 100%;
    position: relative;
    box-sizing: border-box;
}

.qoRBwPwJHREqDumZWju7 {
    flex-wrap: wrap;
}

.l0j4nYAPeqU9nf2RsUgq {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    width: 100%;
    gap: 8px;
    padding: 0;
    background-color: transparent;
    flex-direction: row-reverse;
}

.dSMGnPeHOOiwlPKhpw9E {
    max-width: calc(100% - 50px);
}

.qoRBwPwJHREqDumZWju7 .l0j4nYAPeqU9nf2RsUgq {
    flex-wrap: wrap;
    flex-direction: row;
}
  
.ETTr_ea7y6Em20I6lPI4 {
    width: 5px;
    height: 5px;
    padding: 0;
    background-color: #c5c5c5;
    border: none;
    cursor: pointer;
    border-radius: 50%;
    transition: all 0.2s ease;
    transition: background-color 0.2s ease, border 0.2s ease, color 0.2s ease;
    margin: auto 0;
}

.ETTr_ea7y6Em20I6lPI4:hover {
    background-color: var(--qa-navbarKeyWordButtonMobileActiveBackgroundColor);
}

.ETTr_ea7y6Em20I6lPI4.yu4N5YL0av_p9kuGq8qw {
    width: 7px;
    height: 7px;
    background-color: var(--qa-navbarKeyWordButtonMobileActiveBackgroundColor);
}

`, "",{"version":3,"sources":["webpack://./app/components/NavigationBar/NavigationBar.module.css"],"names":[],"mappings":"AAAA;IACI,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,QAAQ;IACR,WAAW;IACX,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,uBAAuB;IACvB,WAAW;IACX,QAAQ;IACR,UAAU;IACV,6BAA6B;IAC7B,2BAA2B;AAC/B;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,WAAW;IACX,UAAU;IACV,yBAAyB;IACzB,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,yBAAyB;IACzB,yEAAyE;IACzE,cAAc;AAClB;;AAEA;IACI,0EAA0E;AAC9E;;AAEA;IACI,UAAU;IACV,WAAW;IACX,0EAA0E;AAC9E","sourcesContent":[".navigationBar {\n    justify-content: center;\n    flex-direction: row;\n    flex-wrap: wrap;\n    gap: 5px;\n    width: 100%;\n    position: relative;\n    box-sizing: border-box;\n}\n\n.navigationBarExpanded {\n    flex-wrap: wrap;\n}\n\n.buttonGroup {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;\n    width: 100%;\n    gap: 8px;\n    padding: 0;\n    background-color: transparent;\n    flex-direction: row-reverse;\n}\n\n.buttonGroupSmaller {\n    max-width: calc(100% - 50px);\n}\n\n.navigationBarExpanded .buttonGroup {\n    flex-wrap: wrap;\n    flex-direction: row;\n}\n  \n.navKeywordButton {\n    width: 5px;\n    height: 5px;\n    padding: 0;\n    background-color: #c5c5c5;\n    border: none;\n    cursor: pointer;\n    border-radius: 50%;\n    transition: all 0.2s ease;\n    transition: background-color 0.2s ease, border 0.2s ease, color 0.2s ease;\n    margin: auto 0;\n}\n\n.navKeywordButton:hover {\n    background-color: var(--qa-navbarKeyWordButtonMobileActiveBackgroundColor);\n}\n\n.navKeywordButton.active {\n    width: 7px;\n    height: 7px;\n    background-color: var(--qa-navbarKeyWordButtonMobileActiveBackgroundColor);\n}\n\n"],"sourceRoot":""}]);
// Exports
export var navigationBar = `BfgC9Rf78SzqkGXkVG9P`;
export var navigationBarExpanded = `qoRBwPwJHREqDumZWju7`;
export var buttonGroup = `l0j4nYAPeqU9nf2RsUgq`;
export var buttonGroupSmaller = `dSMGnPeHOOiwlPKhpw9E`;
export var navKeywordButton = `ETTr_ea7y6Em20I6lPI4`;
export var active = `yu4N5YL0av_p9kuGq8qw`;
export default ___CSS_LOADER_EXPORT___;
